<template>
    <a
        v-if="urlFormatted.length > 0"
        :href="urlFormatted"
        target="_blank"
        class="avatar-listing-link"
    >
        <CompassAvatarName
            :size="size"
            :firstname="firstname"
            :lastname="lastname"
            :show-caption="false"
        >
            <CompassAvatar
                :color-type="colorType"
                :size="size"
                :initials="initials"
                :type="avatarType"
            />
        </CompassAvatarName>
    </a>
    <span v-else>
        <CompassAvatarName
            :size="size"
            :firstname="firstname"
            :lastname="lastname"
            :show-caption="false"
        >
            <CompassAvatar
                :color-type="colorType"
                :size="size"
                :initials="initials"
                :type="avatarType"
            />
        </CompassAvatarName>
    </span>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            default: 'extra-small',
        },
        id: {
            type: Number,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        firstname: {
            type: String,
            required: true,
        },
        lastname: {
            type: String,
            required: true,
        },
        colorType: {
            type: String,
            required: true,
        },
        initials: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            urlFormatted: '',
            avatarType: 'default',
        };
    },
    created() {
        switch (this.type) {
            case 'corp':
                this.avatarType = 'company';
                break;
            case 'group':
                this.avatarType = 'team';
                break;
            case 'staff':
                this.avatarType = 'default';
                this.urlFormatted = `/staff/${this.id}`;
                break;
            default:
                this.avatarType = 'default';
                this.urlFormatted = '';
        }
    },
};
</script>

<style lang="scss" scoped>
.avatar-listing-link {
    &:hover {
        &::v-deep {
            .compass-avatar-name__name {
                color: var(--colors-common-text-standard-active);
            }
        }
    }
}
</style>
